export default "__VITE_ASSET__ff38997b__"